<template>
  <div>
    <!--TOOLBAR-->
    <tool-bar title="Copy Service Log"></tool-bar>
    <!--CONTAINER VIEW-->
    <v-container
      class="page-container"
      :class="{'mobile pa-4': isMobile, 'py-4 px-5': isTablet}">
      <student-card :student="student"></student-card>
      <service-log-form
        action="copy"
        :arrayLength="1"
        :deliveryModeArray="deliveryModeArray"
        :groupTypeArray="groupTypeArray"
        :index="1"
        :loadData="loadData"
        :medicaidArray="medicaidArray"
        :absentTypesArray="absentTypesArray"
        :absentReasonsArray="absentReasonsArray"
        :absentAlternativesArray="absentAlternativesArray"
        :serviceDeliveredArray="serviceDeliveredArray"
        :showTooltip="showTooltip"
        :student="student"
        :supervisorFlagsArray="supervisorFlagsArray"
        v-on:form:submitted="submitted = true"
      ></service-log-form>
    </v-container>
    <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import * as Constants from '@/constants';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import api from '@/utils/api';
import BottomNav from '@/components/bottom-nav';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import ServiceLogClass from '@/utils/service-log-class';
import ServiceLogForm from '@/components/service-log/form/service-log-form';
import StudentCard from '@/components/service-log/form/student-card';
import StudentClass from '@/utils/student-class';
import Swal from 'sweetalert2';
import Toolbar from '@/components/toolbar';
import utilityFunctions from '@/utils/functions';
import Vue from 'vue';

export default {
  components: {
    BottomNav,
    FullScreenLoadingSpinner,
    ServiceLogForm,
    StudentCard,
    Toolbar
  },
  name: 'SlCopy',
  data() {
    return {
      behaviors: [],
      deliveryModeArray: null,
      groupTypeArray: null,
      loadData: false,
      medicaidArray: null,
      absentTypesArray: null,
      absentReasonsArray: null,
      absentAlternativesArray: null,
      progressCodes: [],
      serviceDeliveredArray: null,
      sessionObjectives: [],
      showLoading: false,
      student: null,
      submissionData: null,
      submitted: false,
      supervisorFlagsArray: null
    };
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    }
  },
  methods: {
    hasInformationChanged() {
      return this.hasServiceInformationChanged() || this.hasMedicaidInformationChanged();
    },
    hasMedicaidInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.medicaid, this.student.form.medicaid);
    },
    hasServiceInformationChanged() {
      return !_.isEqual(Vue.prototype.$savedData.serviceInformation, this.student.form.serviceInformation);
    }
  },
  async created() {
    utilityFunctions.clearSubmissionArray();
    const sessionId = this.$route.params.sessionId;
    this.showLoading = true;
    // Loading student information.
    let data;
    Promise.all([
      api.get(Constants.OTSL_GET_OT_SESSION_URL(sessionId)),
      api.get(Constants.GET_MEDICAID_PROCEDURES_LIST_URL()),
      api.get(Constants.ABSENT_TYPES_URL()),
      api.get(Constants.ABSENT_REASONS_URL()),
      api.get(Constants.ABSENT_ALTERNATIVES_URL()),
      api.get(Constants.GROUP_TYPES_URL()),
      api.get(Constants.DELIVERY_MODES_URL()),
      api.get(Constants.SERVICE_DELIVERED_URL())
    ])
      .then((submission) => {
        data = submission[0].data.data;
        // set medicaid procedures array
        this.medicaidArray = submission[1].data.data;
        // set absentTypesArray
        this.absentTypesArray = submission[2].data.data;
        // set absentReasonsArray
        this.absentReasonsArray = submission[3].data.data;
        // set absentAlternativesArray
        this.absentAlternativesArray = submission[4].data.data;
        // set groupTypeArray
        this.groupTypeArray = submission[5].data.data;
        // set deliveryModeArray
        this.deliveryModeArray = submission[6].data.data;
        // set serviceDeliveredArray
        this.serviceDeliveredArray = submission[7].data.data;
        return api.get(Constants.GET_SERVICE_LOCATIONS_URL(data.locationName));
      })
      .then((school) => {
        data.location = school.data.data[0];
        // need to use vue.set to make the information reactive
        Vue.set(this, 'student', new StudentClass(data));
        const info = new ServiceLogClass(data, false, true);
        // save initialized form data to check if data changed before navigating away
        Vue.prototype.$savedData = _.cloneDeep(info);
        // need to use vue.set to make the information reactive
        Vue.set(this.student, 'form', info);
      })
      .finally(() => {
        this.loadData = true;
        this.showLoading = false;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.submitted) {
      if (this.hasInformationChanged()) {
        Swal.fire({
          text: 'You have unsaved information.  Are you sure you want to leave this page?',
          confirmButtonText: 'OK',
          showCancelButton: true,
          customClass: {
            popup: 'popup-class',
            content: 'content-class',
            confirmButton: 'confirm-button-class'
          }
        }).then((response) => {
          // if ok was clicked
          if (response && response.value) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service-log/copy-service-log.vue